import analyticsApi from "../api/analytics-api";

/** Tolerates either a bare payload or a { data: ... } envelope. */
const unwrap = (res) => (res && res.data !== undefined ? res.data : res);

const analyticsService = {
  getSummary: async (days = 30) => unwrap(await analyticsApi.summary(days)) || {},
  getHistory: async (days = 30) => {
    const data = unwrap(await analyticsApi.history(days));
    return Array.isArray(data) ? data : [];
  },
};

export default analyticsService;
